/** @jsx isolateComponent */

import React, { useState } from 'react';
import { Img, SkeletonBlock } from '@zapier/design-system';
import { ImgProps } from './img-types';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';

type LoadableImgProps = ImgProps;

const Styles = labelStyles(__filename, {
  img: (loaded: boolean) => [
    !loaded &&
      withModifier('loading', {
        position: 'absolute',
        left: -9999,
      }),
  ],
});

const ImgSkeletonLoader: React.FC<LoadableImgProps> = props => {
  const [ratioWidth, ratioHeight] = (props.aspectRatio || '')
    .split(':')
    .map(part => {
      return part && parseFloat(part);
    });
  const aspectRatio =
    ratioWidth && ratioHeight ? ratioWidth / ratioHeight : undefined;
  return (
    <SkeletonBlock
      aspectRatio={aspectRatio}
      height={props.height}
      width={props.width === null ? undefined : props.width}
    />
  );
};

/**
 * Displays a block level loading placeholder while Img is loading.
 *
 * Accepts all props from Img and passes them through.
 *
 * Tags: core-ui
 */

const LoadableImg: React.FC<LoadableImgProps> = props => {
  const [loaded, setLoaded] = useState(false);

  const onLoad = (event: any) => {
    if (typeof props.onLoad === 'function') {
      props.onLoad(event);
    }
    setLoaded(true);
  };

  return (
    <div>
      <div css={Styles.img(loaded)}>
        <Img {...props} onLoad={onLoad} />
      </div>
      {!loaded && <ImgSkeletonLoader {...props} />}
    </div>
  );
};

export default LoadableImg;
